module.exports = __webpack_public_path__ + "img/invoice.088aaa30.svg";